__turbopack_context__.v({
  "pullLeft": "floats-module-scss-module__INKWMW__pullLeft",
  "pullLeftLg": "floats-module-scss-module__INKWMW__pullLeftLg",
  "pullLeftMd": "floats-module-scss-module__INKWMW__pullLeftMd",
  "pullLeftSm": "floats-module-scss-module__INKWMW__pullLeftSm",
  "pullLeftXs": "floats-module-scss-module__INKWMW__pullLeftXs",
  "pullNone": "floats-module-scss-module__INKWMW__pullNone",
  "pullNoneLg": "floats-module-scss-module__INKWMW__pullNoneLg",
  "pullNoneMd": "floats-module-scss-module__INKWMW__pullNoneMd",
  "pullNoneSm": "floats-module-scss-module__INKWMW__pullNoneSm",
  "pullNoneXs": "floats-module-scss-module__INKWMW__pullNoneXs",
  "pullRight": "floats-module-scss-module__INKWMW__pullRight",
  "pullRightLg": "floats-module-scss-module__INKWMW__pullRightLg",
  "pullRightMd": "floats-module-scss-module__INKWMW__pullRightMd",
  "pullRightSm": "floats-module-scss-module__INKWMW__pullRightSm",
  "pullRightXs": "floats-module-scss-module__INKWMW__pullRightXs",
});
